import React from 'react'
import { Portal } from '../'
import { LocationForm } from '.'
import { X } from 'react-feather'

const LocationPopup = ({
  title = 'Add Location',
  onClose,
  onSave,
  locationToEdit
}) => {
  const handleClose = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onClose === 'function'){
      onClose(false)
    }
  }

  return (
    <Portal>
      <div
        className="fixed left-0 top-0 w-full h-screen overflow-y-auto"
        style={{zIndex: 900, background: 'rgba(0, 0, 0, 0.75)'}}
        onClick={handleClose}
      >
        <div className="container mx-auto pt-40 lg:pt-0 my-10" onClick={(e) => e.stopPropagation()}>
          <div className="w-full lg:w-6/12 mx-auto px-4 py-5 lg:px-8 lg:py-8 bg-white rounded">
            <div className="lg:w-auto mx-auto">
              <div className="flex justify-between items-center mb-5">
                <h1 className="text-lg lg:text-3xl text-left font-bold font-primary">
                  {title}
                </h1>
                <X className="cursor-pointer" onClick={handleClose}/>
              </div>

              <hr className="mb-5 lg:mb-10"/>

              <LocationForm onSave={onSave} onCancel={onClose} locationToEdit={locationToEdit} />
            </div>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export { LocationPopup }
